"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

/*
 * Checks for true
 * @params value
 * @return boolean
 */
var isTrue = function isTrue(value) {
  return value === true;
};

/*
 * Checks for false
 * @params value
 * @return boolean
 */
var isFalse = function isFalse(value) {
  return value === false;
};

/*
 * Export constant bool
 */
var bool = exports.bool = {
  isTrue: isTrue,
  isFalse: isFalse
};